import ProductDescriptionCard from "./productDescriptionCard";

interface ProductDescription {
  type: string;
  standardMaterial: string;
  pressure: string;
  temperature: string;
  surfaceSpeed: string;
  stock: number;
  unlimited: boolean;
}

interface Category {
  id: number;
  categoryName: string;
}

interface SubCategory {
  id: number;
  subCategoryname: string;
}

interface ProductFormProps {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;

  categories: Category[];
  subCategories: SubCategory[];

  categoryId: number;
  setCategoryId: React.Dispatch<React.SetStateAction<number>>;

  subCategoryId: number;
  setSubCategoryId: React.Dispatch<React.SetStateAction<number>>;

  isActive: boolean;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;

  descriptions: ProductDescription[];
  setDescriptions: React.Dispatch<React.SetStateAction<ProductDescription[]>>;
}

export default function ProductForm({
  name,
  setName,
  categories,
  subCategories,
  categoryId,
  setCategoryId,
  subCategoryId,
  setSubCategoryId,
  isActive,
  setIsActive,
  descriptions,
  setDescriptions,
}: ProductFormProps) {
  // nanti diganti useState

  const handleAddDescription = () => {
    setDescriptions((prev) => [
      ...prev,
      {
        type: "",
        standardMaterial: "",
        pressure: "",
        temperature: "",
        surfaceSpeed: "",
        stock: 0,
        unlimited: false,
      },
    ]);
  };

  const handleDeleteDescription = (index: number) => {
    setDescriptions((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-8">
      {/* Product Name */}
      <div>
        <label className="mb-2 block font-semibold">Product Name</label>

        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Type here..."
          className="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none focus:border-blue-500"
        />
      </div>

      {/* Brand */}
      {/* <div>
        <label className="mb-2 block font-semibold">Brand</label>

        <select className="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none">
          <option>Select Brand</option>
        </select>
      </div> */}

      {/* Category */}
      <div>
        <label className="mb-2 block font-semibold">Category</label>

        <select
          value={categoryId}
          onChange={(e) => setCategoryId(Number(e.target.value))}
          className="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none">
          <option value={0}>Select Category</option>

          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.categoryName}
            </option>
          ))}
        </select>
      </div>

      {/* Sub Category */}
      <div>
        <label className="mb-2 block font-semibold">Sub Category</label>

        <select
          value={subCategoryId}
          onChange={(e) => setSubCategoryId(Number(e.target.value))}
          className="h-12 w-full rounded-xl border border-gray-300 px-4 outline-none">
          <option value={0}>Select Sub Category</option>

          {subCategories.map((subCategory) => (
            <option key={subCategory.id} value={subCategory.id}>
              {subCategory.subCategoryname}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-3">
        <label>Active</label>

        <input
          type="checkbox"
          checked={isActive}
          onChange={(e) => setIsActive(e.target.checked)}
        />
      </div>

      {/* Product Description */}
      <div className="space-y-6">
        <h2 className="text-xl font-bold">Product Description</h2>

        {descriptions.map((description, index) => (
          <ProductDescriptionCard
            key={index}
            index={index}
            description={description}
            setDescriptions={setDescriptions}
            onDelete={() => handleDeleteDescription(index)}
          />
        ))}

        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleAddDescription}
            className="rounded-xl bg-blue-600 px-8 py-3 font-medium text-white hover:bg-blue-700">
            + Add Item
          </button>
        </div>
      </div>
    </div>
  );
}
